export default __webpack_public_path__ + "static/media/money_pig.400da728.svg";